import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Container, Btn } from "@/components/kit";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const label = "t-caption font-mono uppercase tracking-wide text-[var(--muted)]";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await register(f.name.trim(), f.email.trim(), f.password);
      nav("/account", { replace: true });
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message);
    }
    setBusy(false);
  };

  return (
    <>
      <Seo title="Create account" canonical="/register" description="Create a Prox account." />
      <PageHero eyebrow="Account" crumbs={[{ label: "Home", to: "/" }, { label: "Create account" }]} title="Create your account." lead="Set up a Prox account with your email and a password." />
      <Section bg="bone">
        <Container size="sm" className="!px-0">
          <form onSubmit={submit} className="space-y-6 max-w-md" data-testid="register-form">
            <label className="block"><span className={label}>Your name</span>
              <input className="field mt-2" value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="register-name" autoComplete="name" /></label>
            <label className="block"><span className={label}>Email</span>
              <input type="email" className="field mt-2" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="register-email" autoComplete="email" /></label>
            <label className="block"><span className={label}>Password</span>
              <input type="password" className="field mt-2" value={f.password} onChange={(e) => set("password", e.target.value)} data-testid="register-password" autoComplete="new-password" />
              <span className="block t-caption text-[var(--muted)] mt-1">At least 8 characters.</span></label>
            {err && <p className="t-sm text-[#a24f3a]" data-testid="register-error">{err}</p>}
            <Btn type="submit" variant="clay" className="w-full justify-center" data-testid="register-submit">{busy ? "Creating\u2026" : "Create account"}</Btn>
            <p className="t-sm text-[var(--muted)]">Already have an account? <Link to="/login" className="lnk">Log in</Link>.</p>
          </form>
        </Container>
      </Section>
    </>
  );
}
